import React from 'react'
import { Button, Divider, Menu, Dropdown, Avatar } from "antd";
import { Link } from 'react-router-dom';
import Logo from '../assets/images/logo/logo.webp'
import { logo_holiday, logo_hotel } from '../utils/ImagePath';
import { capitalizeWords } from '../utils/Constants';
import { FaChevronDown, FaHotel, FaPlane, FaRegUser, FaSignOutAlt, FaTicketAlt, FaUmbrellaBeach } from 'react-icons/fa';
import { setModal2Open } from '../redux/hotel/modalSlice';
import { useDispatch } from 'react-redux';

const Sidebar = ({ onClose, modal2Open }) => {
    let isUserType = JSON.parse(localStorage.getItem('isUserType'));
    let getUser = JSON.parse(localStorage.getItem('user'));
    
    const getLogo = () => {
        if (
            location.pathname === "/flights" ||
            location.pathname === "/flight-review" ||
            location.pathname.startsWith("/flights")
        ) {
            return Logo; // Flights logo
        } else if (
            location.pathname === "/hotels" ||
            location.pathname.startsWith("/hotels") ||
            location.pathname === "/hotel-details" ||
            location.pathname === "/hotel-payment"
        ) {
            return logo_hotel; // Hotels logo
        } else if (
            location.pathname === "/holiday" ||
            location.pathname.startsWith("/holiday") ||
            location.pathname.startsWith("/package") ||
            location.pathname.startsWith("/destination") ||
            location.pathname === "/package-home"
        ) {
            return logo_holiday; // Holiday logo
        } else {
            return Logo;
        }
    };
    const dispatch = useDispatch();
    const logout = () => {
        localStorage.clear();
    }

    const items = [
        {
            key: '1',
            label: (
                <>
                    <Link onClick={onClose} to="/create-profile" aria-label="View Profile" className="text-decoration-none">
                        <div className="d-flex">
                            <FaRegUser />
                            <div className="user-info">
                                <Link onClick={onClose} to="/create-profile" aria-label="View Profile" className='ms-2'>View Profile</Link>
                            </div>
                        </div>
                    </Link>

                </>
            ),
        },
        {
            key: '2',
            label: (
                <Link onClick={onClose} to="/my-booking" aria-label="My Booking" className="text-decoration-none">
                    <div className="d-flex">
                        <FaTicketAlt />
                        <div className="user-info">
                            <Link onClick={onClose} to="/my-booking" aria-label="My Booking" className='ms-2'>My Booking</Link>
                        </div>
                    </div>
                </Link>
            ),
        },
        {
            key: '3',
            label: (
                <Link onClick={onClose} to="/my-wallet" aria-label="My Booking" className="text-decoration-none">
                    <div className="d-flex" >
                        <FaSignOutAlt />
                        <div className="user-info">
                            <Link to="/my-wallet" aria-label="Logout" className='ms-2'>My Wallet</Link>
                            <br />
                            {/* <p>View Profile</p> */}
                        </div>
                    </div>
                </Link>
            ),
        },
        {
            key: '4',
            label: (
                <Link to="/" onClick={() => { onClose(); logout(); }}>
                    <div className="d-flex" >
                        <FaSignOutAlt />
                        <div className="user-info">
                            <Link to="/" aria-label="Logout" className='ms-2'>Logout</Link>
                            <br />
                            {/* <p>View Profile</p> */}
                        </div>
                    </div>
                </Link>
            ),
        },
    ];

    return (
        <>
            <div className='sidebar-menu'>
                <Menu mode="inline">
                    <a href="#" className="brand">
                        <img loading="lazy" src={getLogo()} alt="SuperbWorldTrip" height={'55px'} width={'174px'} className="img-fluid" />
                    </a>

                    <div className='mt-4'>
                        <Menu key="Flights" className='menu-link'>
                            <Link onClick={onClose} to="/flights"><FaPlane /> Flights</Link>
                        </Menu>
                        <Divider className='my-1' />
                        {/* <Menu.Item key="Bus" className='menu-link'>
                        <Link to="/bus">Bus</Link>
                    </Menu.Item> */}
                        <Menu onClick={onClose} key="Hotels" className='menu-link'>
                            <Link onClick={onClose} to="/hotels"><FaHotel /> Hotels</Link>
                        </Menu>
                        <Divider className='my-1' />
                        <Menu key="holiday" className='menu-link'>
                            <Link onClick={onClose} to="/holiday"><FaUmbrellaBeach /> Holidays</Link>
                        </Menu>
                        <Divider onClick={onClose} className='my-1' />

                        <Menu key="offers" className='menu-link'>
                            <Link onClick={onClose} to="/offers">
                            <svg fill="var(--primary-color)" width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"></path></g></svg>
                              Offers</Link>
                        </Menu>
                        <Divider onClick={onClose} className='my-1' />
                         <Menu key="about-us" className='menu-link'>
                            <Link onClick={onClose} to="/about-us">
                            <svg fill="var(--primary-color)" width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"></path></g></svg>
                              About Us</Link>
                        </Menu>
                        <Divider className='my-1' />
                        <div className='mt-4'>
                            {!isUserType ?
                                <Button onClick={() => { onClose(); dispatch(setModal2Open(true)) }} className="btn btn-primary menu-block" aria-label="login Register">
                                    <span className='lh-sm'>Login/Register</span>
                                </Button> :
                                <Dropdown
                                    menu={{ items, }}
                                    placement="bottom"
                                    arrow={{ pointAtCenter: true, }}
                                    className="profile-name d-flex align-item-center "
                                >
                                    <Button className="btn btn-primary" aria-label="Name">
                                        <Avatar
                                            className="me-2"
                                            style={{
                                                backgroundColor: 'rgb(253 227 207 / 51%)',
                                                color: '#f56a00',
                                                display: "flex",
                                                alignItem: "center",
                                                fontWeight: "600"
                                            }}
                                        >
                                            {`${getUser?.firstName?.charAt(0)}`}
                                        </Avatar>
                                        <span className="text-truncate">Hey {capitalizeWords(getUser?.firstName)}</span><FaChevronDown />
                                    </Button>
                                </Dropdown>
                            }
                        </div>




                    </div>
                </Menu>
            </div>
        </>
    )
}

export default Sidebar